/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import { GetPassengersWaypointFragmentDoc } from '../../../../ad-passenger-list/src/lib/utils/passenger-filters.hook'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type AdVehicleStreamServiceCancellationVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  fccCurrentAdAlerts: {
    __typename?: 'FccAdAlerts'
    alerts: Array<{
      __typename?: 'FccAdAlert'
      id: string
      type: Types.FccAdAlertType
      status: Types.FccAdAlertStatus
    }>
  } | null
  fccUpcomingWaypoints: Array<{
    __typename?: 'FccWaypoint'
    adState: Types.FccWaypointState | null
    fccStop: {
      __typename?: 'FccStop'
      id: string | null
      names: Partial<Record<'de' | 'en' | 'no', string>>
    } | null
    stopWithServiceArea: {
      __typename?: 'Stop'
      id: string
      serviceArea: { __typename?: 'ServiceArea'; id: string }
    } | null
    actions: Array<
      | {
          __typename: 'FccWaypointDeliveryAction'
          id: string
          estimatedAt: string
          pickedUpAt: string | null
          trip: { __typename?: 'Trip'; id: string } | null
          customer: {
            __typename?: 'Customer'
            firstName: string | null
            lastName: string | null
            extendedWalkingTime: boolean
            visualImpairment: boolean | null
          } | null
          ridePassengerInfo: {
            __typename?: 'FccRidePassengerInfo'
            customerId: string | null
            displayName: string | null
            boardingRequirements: {
              __typename?: 'FccBoardingRequirements'
              headCount: number
              childSeat: boolean
              wheelchair: boolean
            } | null
            impairments: {
              __typename?: 'FccImpairments'
              visual: boolean
            } | null
          } | null
          seats: {
            __typename?: 'FccWaypointSeatInfo'
            seats: number
            wheelchairs: number
            childSeats: number
            boosterSeats: number
          }
        }
      | { __typename?: 'FccWaypointHubReturnAction' }
      | {
          __typename: 'FccWaypointPickupAction'
          id: string
          estimatedAt: string
          pickedUpAt: string | null
          adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
          notShownUpAt: string | null
          tripIsCancelled: boolean | null
          trip: { __typename?: 'Trip'; id: string } | null
          customer: {
            __typename?: 'Customer'
            firstName: string | null
            lastName: string | null
            extendedWalkingTime: boolean
            visualImpairment: boolean | null
          } | null
          ridePassengerInfo: {
            __typename?: 'FccRidePassengerInfo'
            customerId: string | null
            displayName: string | null
            boardingRequirements: {
              __typename?: 'FccBoardingRequirements'
              headCount: number
              childSeat: boolean
              wheelchair: boolean
            } | null
            impairments: {
              __typename?: 'FccImpairments'
              visual: boolean
            } | null
          } | null
          seats: {
            __typename?: 'FccWaypointSeatInfo'
            seats: number
            wheelchairs: number
            childSeats: number
            boosterSeats: number
          }
        }
      | { __typename?: 'FccWaypointReallocationAction' }
    >
  }> | null
}

export type AdVehicleStreamInitiateServiceCancellationMutationVariables =
  Types.Exact<{
    vehicleId: Types.Scalars['ID']['input']
    incidentId?: Types.InputMaybe<Types.Scalars['ID']['input']>
    cancellationType: Types.FccServiceCancellationTypeEnum
  }>

export type AdVehicleStreamInitiateServiceCancellationMutation = {
  __typename?: 'Mutation'
  fccInitiateServiceCancellation: any | null
}

export type AdVehicleStreamConfirmCancelAllTripsMutationVariables =
  Types.Exact<{
    vehicleId: Types.Scalars['ID']['input']
  }>

export type AdVehicleStreamConfirmCancelAllTripsMutation = {
  __typename?: 'Mutation'
  fccConfirmCancelAllTrips: any | null
}

export type AdVehicleStreamContinueTripsMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
  incidentId?: Types.InputMaybe<Types.Scalars['ID']['input']>
}>

export type AdVehicleStreamContinueTripsMutation = {
  __typename?: 'Mutation'
  fccContinueTrips: any | null
}

export type AdVehicleStreamRestoreMissionMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type AdVehicleStreamRestoreMissionMutation = {
  __typename?: 'Mutation'
  fccRestoreMission: any | null
}

export type AdVehicleStreamConfirmCancelSomeTripsMutationVariables =
  Types.Exact<{
    vehicleId: Types.Scalars['ID']['input']
    tripIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']
  }>

export type AdVehicleStreamConfirmCancelSomeTripsMutation = {
  __typename?: 'Mutation'
  fccConfirmCancelSomeTrips: any | null
}

export const AdVehicleStreamServiceCancellationVehicleFragmentDoc = gql`
    fragment AdVehicleStreamServiceCancellationVehicle on Vehicle {
  id
  fccCurrentAdAlerts {
    alerts {
      id
      type
      status
    }
  }
  fccUpcomingWaypoints {
    ...GetPassengersWaypoint
    adState
  }
}
    ${GetPassengersWaypointFragmentDoc}`
export const AdVehicleStreamInitiateServiceCancellationDocument = gql`
    mutation AdVehicleStreamInitiateServiceCancellation($vehicleId: ID!, $incidentId: ID, $cancellationType: FccServiceCancellationTypeEnum!) {
  fccInitiateServiceCancellation(
    input: {vehicleId: $vehicleId, incidentId: $incidentId, cancellationType: $cancellationType}
  )
}
    `
export type AdVehicleStreamInitiateServiceCancellationMutationFn =
  Apollo.MutationFunction<
    AdVehicleStreamInitiateServiceCancellationMutation,
    AdVehicleStreamInitiateServiceCancellationMutationVariables
  >

/**
 * __useAdVehicleStreamInitiateServiceCancellationMutation__
 *
 * To run a mutation, you first call `useAdVehicleStreamInitiateServiceCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdVehicleStreamInitiateServiceCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adVehicleStreamInitiateServiceCancellationMutation, { data, loading, error }] = useAdVehicleStreamInitiateServiceCancellationMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *      incidentId: // value for 'incidentId'
 *      cancellationType: // value for 'cancellationType'
 *   },
 * });
 */
export function useAdVehicleStreamInitiateServiceCancellationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdVehicleStreamInitiateServiceCancellationMutation,
    AdVehicleStreamInitiateServiceCancellationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdVehicleStreamInitiateServiceCancellationMutation,
    AdVehicleStreamInitiateServiceCancellationMutationVariables
  >(AdVehicleStreamInitiateServiceCancellationDocument, options)
}
export type AdVehicleStreamInitiateServiceCancellationMutationHookResult =
  ReturnType<typeof useAdVehicleStreamInitiateServiceCancellationMutation>
export type AdVehicleStreamInitiateServiceCancellationMutationResult =
  Apollo.MutationResult<AdVehicleStreamInitiateServiceCancellationMutation>
export type AdVehicleStreamInitiateServiceCancellationMutationOptions =
  Apollo.BaseMutationOptions<
    AdVehicleStreamInitiateServiceCancellationMutation,
    AdVehicleStreamInitiateServiceCancellationMutationVariables
  >
export const AdVehicleStreamConfirmCancelAllTripsDocument = gql`
    mutation AdVehicleStreamConfirmCancelAllTrips($vehicleId: ID!) {
  fccConfirmCancelAllTrips(input: {vehicleId: $vehicleId})
}
    `
export type AdVehicleStreamConfirmCancelAllTripsMutationFn =
  Apollo.MutationFunction<
    AdVehicleStreamConfirmCancelAllTripsMutation,
    AdVehicleStreamConfirmCancelAllTripsMutationVariables
  >

/**
 * __useAdVehicleStreamConfirmCancelAllTripsMutation__
 *
 * To run a mutation, you first call `useAdVehicleStreamConfirmCancelAllTripsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdVehicleStreamConfirmCancelAllTripsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adVehicleStreamConfirmCancelAllTripsMutation, { data, loading, error }] = useAdVehicleStreamConfirmCancelAllTripsMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useAdVehicleStreamConfirmCancelAllTripsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdVehicleStreamConfirmCancelAllTripsMutation,
    AdVehicleStreamConfirmCancelAllTripsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdVehicleStreamConfirmCancelAllTripsMutation,
    AdVehicleStreamConfirmCancelAllTripsMutationVariables
  >(AdVehicleStreamConfirmCancelAllTripsDocument, options)
}
export type AdVehicleStreamConfirmCancelAllTripsMutationHookResult = ReturnType<
  typeof useAdVehicleStreamConfirmCancelAllTripsMutation
>
export type AdVehicleStreamConfirmCancelAllTripsMutationResult =
  Apollo.MutationResult<AdVehicleStreamConfirmCancelAllTripsMutation>
export type AdVehicleStreamConfirmCancelAllTripsMutationOptions =
  Apollo.BaseMutationOptions<
    AdVehicleStreamConfirmCancelAllTripsMutation,
    AdVehicleStreamConfirmCancelAllTripsMutationVariables
  >
export const AdVehicleStreamContinueTripsDocument = gql`
    mutation AdVehicleStreamContinueTrips($vehicleId: ID!, $incidentId: ID) {
  fccContinueTrips(input: {vehicleId: $vehicleId, incidentId: $incidentId})
}
    `
export type AdVehicleStreamContinueTripsMutationFn = Apollo.MutationFunction<
  AdVehicleStreamContinueTripsMutation,
  AdVehicleStreamContinueTripsMutationVariables
>

/**
 * __useAdVehicleStreamContinueTripsMutation__
 *
 * To run a mutation, you first call `useAdVehicleStreamContinueTripsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdVehicleStreamContinueTripsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adVehicleStreamContinueTripsMutation, { data, loading, error }] = useAdVehicleStreamContinueTripsMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *      incidentId: // value for 'incidentId'
 *   },
 * });
 */
export function useAdVehicleStreamContinueTripsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdVehicleStreamContinueTripsMutation,
    AdVehicleStreamContinueTripsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdVehicleStreamContinueTripsMutation,
    AdVehicleStreamContinueTripsMutationVariables
  >(AdVehicleStreamContinueTripsDocument, options)
}
export type AdVehicleStreamContinueTripsMutationHookResult = ReturnType<
  typeof useAdVehicleStreamContinueTripsMutation
>
export type AdVehicleStreamContinueTripsMutationResult =
  Apollo.MutationResult<AdVehicleStreamContinueTripsMutation>
export type AdVehicleStreamContinueTripsMutationOptions =
  Apollo.BaseMutationOptions<
    AdVehicleStreamContinueTripsMutation,
    AdVehicleStreamContinueTripsMutationVariables
  >
export const AdVehicleStreamRestoreMissionDocument = gql`
    mutation AdVehicleStreamRestoreMission($vehicleId: ID!) {
  fccRestoreMission(input: {vehicleId: $vehicleId})
}
    `
export type AdVehicleStreamRestoreMissionMutationFn = Apollo.MutationFunction<
  AdVehicleStreamRestoreMissionMutation,
  AdVehicleStreamRestoreMissionMutationVariables
>

/**
 * __useAdVehicleStreamRestoreMissionMutation__
 *
 * To run a mutation, you first call `useAdVehicleStreamRestoreMissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdVehicleStreamRestoreMissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adVehicleStreamRestoreMissionMutation, { data, loading, error }] = useAdVehicleStreamRestoreMissionMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useAdVehicleStreamRestoreMissionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdVehicleStreamRestoreMissionMutation,
    AdVehicleStreamRestoreMissionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdVehicleStreamRestoreMissionMutation,
    AdVehicleStreamRestoreMissionMutationVariables
  >(AdVehicleStreamRestoreMissionDocument, options)
}
export type AdVehicleStreamRestoreMissionMutationHookResult = ReturnType<
  typeof useAdVehicleStreamRestoreMissionMutation
>
export type AdVehicleStreamRestoreMissionMutationResult =
  Apollo.MutationResult<AdVehicleStreamRestoreMissionMutation>
export type AdVehicleStreamRestoreMissionMutationOptions =
  Apollo.BaseMutationOptions<
    AdVehicleStreamRestoreMissionMutation,
    AdVehicleStreamRestoreMissionMutationVariables
  >
export const AdVehicleStreamConfirmCancelSomeTripsDocument = gql`
    mutation AdVehicleStreamConfirmCancelSomeTrips($vehicleId: ID!, $tripIds: [ID!]!) {
  fccConfirmCancelSomeTrips(input: {vehicleId: $vehicleId, tripIds: $tripIds})
}
    `
export type AdVehicleStreamConfirmCancelSomeTripsMutationFn =
  Apollo.MutationFunction<
    AdVehicleStreamConfirmCancelSomeTripsMutation,
    AdVehicleStreamConfirmCancelSomeTripsMutationVariables
  >

/**
 * __useAdVehicleStreamConfirmCancelSomeTripsMutation__
 *
 * To run a mutation, you first call `useAdVehicleStreamConfirmCancelSomeTripsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdVehicleStreamConfirmCancelSomeTripsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adVehicleStreamConfirmCancelSomeTripsMutation, { data, loading, error }] = useAdVehicleStreamConfirmCancelSomeTripsMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *      tripIds: // value for 'tripIds'
 *   },
 * });
 */
export function useAdVehicleStreamConfirmCancelSomeTripsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdVehicleStreamConfirmCancelSomeTripsMutation,
    AdVehicleStreamConfirmCancelSomeTripsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdVehicleStreamConfirmCancelSomeTripsMutation,
    AdVehicleStreamConfirmCancelSomeTripsMutationVariables
  >(AdVehicleStreamConfirmCancelSomeTripsDocument, options)
}
export type AdVehicleStreamConfirmCancelSomeTripsMutationHookResult =
  ReturnType<typeof useAdVehicleStreamConfirmCancelSomeTripsMutation>
export type AdVehicleStreamConfirmCancelSomeTripsMutationResult =
  Apollo.MutationResult<AdVehicleStreamConfirmCancelSomeTripsMutation>
export type AdVehicleStreamConfirmCancelSomeTripsMutationOptions =
  Apollo.BaseMutationOptions<
    AdVehicleStreamConfirmCancelSomeTripsMutation,
    AdVehicleStreamConfirmCancelSomeTripsMutationVariables
  >
